/* eslint-disable no-empty-pattern */
/**
 * @author
 * @description 考试管理模块
 */

import {
  getExamClassRegisterList,
  getExamStudentRegisterList,
  openExamActivity,
  createExamActivity,
  getExamActivityDetail,
  getExamDetail,
  getExamByStudentOrClass,
  getExamRegister,
  getRegisterStudent,
  getAddStudent,
  editExamActivity,
  deleteExamActivity,
  addExamArrangeStudent,
  getExamList,
  getExamStudentList,
  registerExam,
  getExamClassList,
  getExamActivityStudent,
  unregisterExam,
  getMyActivityList,
  replyQuestion,
  leaveRecord,
  submitActivity,
  examActivity,
  teacherMarkingList,
  markingStuList,
  departmentList,
  markDetail,
  markGrade,
  copyExam,
  examGradeList,
  examStuGradeList,
  stuExamPaperDetail,
  stuExamStuGradeList,
  stuExamGradeList,
  examAnalysis,
  examAnalysisList,
  examTeachers,
  examSection,
  stuGradePage,
  changeStuGrade,
  examCourseList,
  examCourseCategoryList,
  examRecycleList,
  examRecycleDelList,
  recycleRestore,
} from "@/api/exam";

import request from "@/utils/request";
// import { reject } from "core-js/fn/promise";

const state = () => ({});

const getters = {};
// 同步方法写在这里--对应commit
const mutations = {};
// 异步请求写在这里--对应dispatch
const actions = {
  // 开考教员获取考试安排列表
  getOpenTeacherExamArrangeList({}, data) {
    return request({
      url: "local_exam_open_teacher_activity_list",
      method: "GET",
      params: data,
    });
  },

  // 获取考试安排列表
  getExamArrangeList({}, data) {
    return request({
      url: "local_exam_search_exam_activity",
      method: "GET",
      params: data,
    });
  },
  // 获取考试安排详情
  getExamArrangeDetail({}, data) {
    return request({
      url: "local_exam_read_exam_activity",
      method: "GET",
      params: data,
    });
  },
  // 批量删除考试安排
  deleteExamActivity({}, data) {
    return new Promise((resolve, reject) => {
      deleteExamActivity(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 人工开考某一考试活动
  openExamActivity({}, data) {
    return new Promise((resolve, reject) => {
      openExamActivity(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 查看考试活动详情
  getExamActivityDetail({}, data) {
    return new Promise((resolve, reject) => {
      getExamActivityDetail(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取某一考试详情
  getExamDetail({}, data) {
    return new Promise((resolve, reject) => {
      getExamDetail(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取根据班级或学员获取已注册考试列表
  getExamByStudentOrClass({}, data) {
    return new Promise((resolve, reject) => {
      getExamByStudentOrClass(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 根据考试获取已注册学员或班级
  getExamRegister({}, data) {
    return new Promise((resolve, reject) => {
      getExamRegister(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取已注册考试学员
  getRegisterStudent({}, data) {
    return new Promise((resolve, reject) => {
      getRegisterStudent(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取已添加学员
  getAddStudent({}, data) {
    return new Promise((resolve, reject) => {
      getAddStudent(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 添加考试活动
  createExamActivity({}, data) {
    return new Promise((resolve, reject) => {
      createExamActivity(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 编辑考试活动
  editExamActivity({}, data) {
    return new Promise((resolve, reject) => {
      editExamActivity(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 添加考试活动学员
  addExamArrangeStudent({}, data) {
    return new Promise((resolve, reject) => {
      addExamArrangeStudent(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试注册-获取班级注册列表接口
  getExamClassRegisterList({}, data) {
    // console.log("getExamClassRegisterList", data);
    return new Promise((resolve, reject) => {
      getExamClassRegisterList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 考试注册-获取学员注册列表接口
  getExamStudentRegisterList({}, data) {
    // console.log("getExamClassRegisterList", data);
    return new Promise((resolve, reject) => {
      getExamStudentRegisterList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 考试注册-获取考试列表接口
  getExamList({}, data) {
    return new Promise((resolve, reject) => {
      getExamList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试注册-获取学员列表接口
  getExamStudentList({}, data) {
    return new Promise((resolve, reject) => {
      getExamStudentList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试注册-获取班级列表
  getExamClassList({}, data) {
    return new Promise((resolve, reject) => {
      getExamClassList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试注册-注册学员
  registerExam({}, data) {
    return new Promise((resolve, reject) => {
      registerExam(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试注册-取消注册学员
  unregisterExam({}, data) {
    return new Promise((resolve, reject) => {
      unregisterExam(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试注册-获取应考人员列表
  getExamActivityStudent({}, data) {
    return new Promise((resolve, reject) => {
      getExamActivityStudent(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 学员端-我的考试列表
  getMyActivityList({}, data) {
    return new Promise((resolve, reject) => {
      getMyActivityList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 学员端-答题
  replyQuestion({}, data) {
    return new Promise((resolve, reject) => {
      replyQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 学员端-纪录切屏次数
  leaveRecord({}, data) {
    return new Promise((resolve, reject) => {
      leaveRecord(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 学员端-交卷
  submitActivity({}, data) {
    return new Promise((resolve, reject) => {
      submitActivity(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 考试类型
  examActivity({}, data) {
    return new Promise((resolve, reject) => {
      examActivity(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 教师考试阅卷
  teacherMarkingList({}, data) {
    return new Promise((resolve, reject) => {
      teacherMarkingList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 参与考试学生列表
  markingStuList({}, data) {
    return new Promise((resolve, reject) => {
      markingStuList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取考试单位的列表
  departmentList({}, data) {
    return new Promise((resolve, reject) => {
      departmentList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取阅卷详情接口
  markDetail({}, data) {
    return new Promise((resolve, reject) => {
      markDetail(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 阅卷评分接口
  markGrade({}, data) {
    return new Promise((resolve, reject) => {
      markGrade(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 阅卷评分接口
  copyExam({}, data) {
    return new Promise((resolve, reject) => {
      copyExam(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examGradeList({}, data) {
    return new Promise((resolve, reject) => {
      examGradeList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examStuGradeList({}, data) {
    return new Promise((resolve, reject) => {
      examStuGradeList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  stuExamPaperDetail({}, data) {
    return new Promise((resolve, reject) => {
      stuExamPaperDetail(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  stuExamStuGradeList({}, data) {
    return new Promise((resolve, reject) => {
      stuExamStuGradeList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  stuExamGradeList({}, data) {
    return new Promise((resolve, reject) => {
      stuExamGradeList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examAnalysis({}, data) {
    return new Promise((resolve, reject) => {
      examAnalysis(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examAnalysisList({}, data) {
    return new Promise((resolve, reject) => {
      examAnalysisList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examTeachers({}, data) {
    return new Promise((resolve, reject) => {
      examTeachers(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examSection({}, data) {
    return new Promise((resolve, reject) => {
      examSection(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  stuGradePage({}, data) {
    return new Promise((resolve, reject) => {
      stuGradePage(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeStuGrade({}, data) {
    return new Promise((resolve, reject) => {
      changeStuGrade(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examCourseList({}, data) {
    return new Promise((resolve, reject) => {
      examCourseList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examCourseCategoryList({}, data) {
    return new Promise((resolve, reject) => {
      examCourseCategoryList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examRecycleList({}, data) {
    return new Promise((resolve, reject) => {
      examRecycleList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  examRecycleDelList({}, data) {
    return new Promise((resolve, reject) => {
      examRecycleDelList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  recycleRestore({}, data) {
    return new Promise((resolve, reject) => {
      recycleRestore(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
